module.exports = __webpack_public_path__ + "static/media/(LH)-Artesanato-10.40411e41.jpg";